import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { deleteAccount } from "../../../services/userDatails";

class DeleteModal extends Component {
    delete = () => {
        deleteAccount()
            .then(res => {
                this.props.hideDelete();
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/deleteAccountModal.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Delete account
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            className=" text-left model-html-container"
                        >
                            <strong> Please Note </strong>: Deleting your
                            account will cancel any open Memberships as well as
                            remove all data from ProWriter including your writer
                            portfolio, clients, and messages history
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={this.delete}
                        >
                            Delete
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideDelete}
                            className="btn btn-default"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
DeleteModal.contextType = AppContext;
export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/employer/settings/DeleteModal.js